import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Tabs } from "./styles"

import { accessManagementSetEditApplication } from "../../../store/actions/accessManagementActions";

export default props => {
    const dispatch = useDispatch();
    const { TabPane } = Tabs;
    const [activeTab, setActiveTab] = useState([])

    const { editApplication } = useSelector((state) => state.accessManagement);
    
    useEffect( () => {
        // inicialização do ciclo de vida, seta a activeTab como "1"
        callback("1");
    }, [editApplication]);

    function callback(key) {
        if(editApplication) {
            key = "1";
        } 
        
        dispatch(accessManagementSetEditApplication(false));
        setActiveTab(key);
    }

    return (
        <>
            <Tabs defaultActiveKey="1" activeKey={activeTab} onChange={callback}>
                {props.children}
            </Tabs>
        </>
    )
}